import React, { useEffect, useState } from 'react';
import LoaderOverlay from './LoaderOverlay';
import { subscribeToLoader } from '../utils/loaderManager';

const GlobalLoader = () => {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const unsubscribe = subscribeToLoader((isLoading, loaderMessage) => {
      setVisible(isLoading);
      setMessage(loaderMessage || '');
    });
    return () => unsubscribe();
  }, []);

  return <LoaderOverlay open={visible} message={message} />;
};

export default GlobalLoader;

